export default {
    searchHint: 'Try a different search.',
    filtersHint: 'Try a different search or change the filters.'
}
